import { render, staticRenderFns } from "./GameData.vue?vue&type=template&id=22ddbaae&scoped=true&"
import script from "./GameData.vue?vue&type=script&lang=js&"
export * from "./GameData.vue?vue&type=script&lang=js&"
import style0 from "./GameData.vue?vue&type=style&index=0&id=22ddbaae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ddbaae",
  null
  
)

export default component.exports